import { MobileHeaderProps } from "../Model/Mobile.type";


const MobileHeader: React.FC<MobileHeaderProps> = ({ asnDetail }) => {
  return (
    <div className="d-flex justify-content-start mt-3 gap-2">
      <div className="col">
        <div className="top-tab p-3">
          <div><strong>ASN # : </strong> {asnDetail?.id}</div>
        </div>
      </div>
      <div className="col">
        <div className="top-tab p-3">
          <div><strong>Location : </strong> {asnDetail?.door}</div>
        </div>
      </div>
      <div className="col">
        <div className="top-tab p-3">
          <div><strong>Warehouse : </strong> {asnDetail?.warehouse?.code}</div>
        </div>
      </div>
      <div className="col">
        <div className="top-tab p-3">
          <div><strong>Tracking # : </strong> {asnDetail?.tracking_number}</div>
        </div>
      </div>
    </div>
  );
};

export default MobileHeader;
